import React, { useState, useEffect } from "react";
import Call from "./Call";
import "./comm-records-styling.css";
import {
  BsFillArrowUpCircleFill,
  BsFillArrowDownCircleFill,
} from "react-icons/bs";

const CallsContainer = ({ calls, reload }) => {
  const [message, setMessage] = useState();
  const [callsArray, setCallsArray] = useState(calls);
  const [ascending, setAscending] = useState(false);

  useEffect(() => {
    const sortedRecordings = [...calls].sort((a, b) => {
      if (ascending) {
        return a.recordingStart.localeCompare(b.recordingStart);
      } else {
        return b.recordingStart.localeCompare(a.recordingStart);
      }
    });

    setCallsArray(sortedRecordings);
  }, [ascending, calls]);

  return (
    <div className="comm-records-container">
      {calls.length > 0 ? (
        <>
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th
                    className="table-heading"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      border: "1px",
                    }}
                  >
                    <p>Date</p>
                    <div className="table-heading-icon-wrapper">
                      {ascending === true ? (
                        <BsFillArrowUpCircleFill
                          size={18}
                          color="#022536"
                          onClick={() => setAscending(false)}
                          title="Oldest to Newest"
                        />
                      ) : (
                        <BsFillArrowDownCircleFill
                          size={18}
                          color="#022536"
                          onClick={() => setAscending(true)}
                          title="Newest to Oldest"
                        />
                      )}
                    </div>{" "}
                  </th>
                  <th className="table-heading">Time</th>
                  <th className="table-heading">Type</th>
                  <th className="table-heading">From</th>
                  <th className="table-heading">To</th>
                  <th className="table-heading">Duration</th>
                  <th className="table-heading">Play/Download</th>
                  <th className="table-heading">Archive</th>
                </tr>
              </thead>
              <tbody>
                {callsArray.map((call) => (
                  <Call
                    key={call._id}
                    reload={reload}
                    call={call}
                    // from={call.from}
                    // to={call.to}
                    // recordingUrl={call.recordingUrl}
                    // recordingStart={call.recordingStart}
                    // duration={call.recordingDuration}
                    // type={call.type}

                    // archived={call.isArchived}
                  />
                ))}
              </tbody>
            </table>
          </div>
          <p>*Time: 24hr timestamp shown in local timezone.</p>{" "}
        </>
      ) : (
        <p>No voicemails to display.</p>
      )}
    </div>
  );
};

export default CallsContainer;
